export function isIE(): boolean {
  return !!navigator.userAgent.match(/Trident\/7\./);
}
